export default {
    name: 'Nama',
    tel: 'Telefon',
    save: 'Simpan',
    confirm: 'Sahkan',
    cancel: 'Batal',
    delete: 'Padam',
    complete: 'Selesai',
    loading: 'Memuatkan...',
    telEmpty: 'Sila isi telefon',
    nameEmpty: 'Sila isi nama',
    nameInvalid: 'Format nama tidak sah',
    confirmDelete: 'Adakah anda pasti ingin memadam?',
    telInvalid: 'Nombor telefon tidak sah',
    vanCalendar: {
      end: 'Tamat',
      start: 'Mula',
      title: 'Kalendar',
      startEnd: 'Mula/Tamat',
      weekdays: ['Aha', 'Isn', 'Sel', 'Rab', 'Kha', 'Jum', 'Sab'],
      monthTitle: function monthTitle(year, month) {
        return year + "/" + month;
      },
      rangePrompt: function rangePrompt(maxRange) {
        return "Pilih tidak lebih dari " + maxRange + " hari";
      }
    },
    vanCascader: {
      select: 'Pilih'
    },
    vanContactCard: {
      addText: 'Tambah maklumat hubungan'
    },
    vanContactList: {
      addText: 'Tambah kenalan baru'
    },
    vanPagination: {
      prev: 'Sebelum',
      next: 'Seterusnya'
    },
    vanPullRefresh: {
      pulling: 'Tarik untuk muat semula...',
      loosing: 'Lepaskan untuk muat semula...'
    },
    vanSubmitBar: {
      label: 'Jumlah：'
    },
    vanCoupon: {
      unlimited: 'Tiada had',
      discount: function discount(_discount) {
        return _discount * 10 + "% diskaun";
      },
      condition: function condition(_condition) {
        return "Sekurang-kurangnya " + _condition;
      }
    },
    vanCouponCell: {
      title: 'Kupon',
      tips: 'Tiada kupon',
      count: function count(_count) {
        return "Anda mempunyai " + _count + " kupon";
      }
    },
    vanCouponList: {
      empty: 'Tiada kupon',
      exchange: 'Tukar',
      close: 'Tutup',
      enable: 'Boleh digunakan',
      disabled: 'Tidak tersedia',
      placeholder: 'Kod kupon'
    },
    vanAddressEdit: {
      area: 'Kawasan',
      postal: 'Poskod',
      areaEmpty: 'Sila pilih kawasan penerimaan',
      addressEmpty: 'Alamat tidak boleh kosong',
      postalEmpty: 'Poskod tidak sah',
      defaultAddress: 'Tetapkan sebagai alamat default',
      telPlaceholder: 'Telefon',
      namePlaceholder: 'Nama',
      areaPlaceholder: 'Kawasan'
    },
    vanAddressEditDetail: {
      label: 'Alamat',
      placeholder: 'Alamat'
    },
    vanAddressList: {
      add: 'Tambah alamat baru'
    }
  };